import * as React from "react";
import Box from "@mui/joy/Box";
import Drawer from "@mui/joy/Drawer";
import Button from "@mui/joy/Button";
import List from "@mui/joy/List";
import Divider from "@mui/joy/Divider";
import ListItem from "@mui/joy/ListItem";
import ListItemButton from "@mui/joy/ListItemButton";
import { Typography } from "@mui/material";
import velLogo from "../../assets/velorcrypt.jpg";
import { domain } from "../../data";
import InnerMenuAccordian from "./InnerMenuAccordian";
import { Link } from "react-router-dom";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import { useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
// import useAuth from "../../context/AuthProvider";

export default function DrawerBasic() {
	const [open, setOpen] = React.useState(false);
	const navigate = useNavigate();
	// const { auth, setAuth } = useAuth();

	const toggleDrawer = (inOpen) => (event) => {
		if (
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}

		setOpen(inOpen);
	};

	const naviagator = (path) => {
		setOpen(false);
		navigate(path);
	};

	// console.log(auth);
	// kdfnosnvdoi for corrections

	return (
		<Box sx={{ display: "flex" }}>
			<Button
				variant="outlined"
				color="neutral"
				onClick={toggleDrawer(true)}
				sx={{ border: "none" }}>
				<DensityMediumIcon sx={{ height: "1.5rem", color: "white" }} />
			</Button>
			<Drawer
				open={open}
				onClose={toggleDrawer(false)}
				anchor="top"
				sx={{
					width: { xs: "80%", sm: "60%", md: "40%" }, // Responsive widths
					maxWidth: "300px", // Optional: maximum width
				}}>
				{/* <Box
					role="presentation"
					onClick={toggleDrawer(false)}
					onKeyDown={toggleDrawer(false)}>
					<Typography level="h2" fontSize="md" sx={{ my: 2, mx: 2 }}>
						<img
							src={bullbear}
							alt="bbe"
							height="15%"
							width="15%"
							className="inline"
						/>{" "}
						Welcome to {domain} Traders
					</Typography>
					<Divider />
					<Typography
						level="h2"
						fontSize="md"
						sx={{ my: 2, mx: 2, color: "red" }}>
						FOR INDIVIDUALS
					</Typography>
					<Divider />

					<List>
						{[
							"Create a personal brockerage account",
							"Login",
							"About us",
							"Security updates",
						].map((text) => (
							<ListItem key={text}>
								<ListItemButton>-{text}</ListItemButton>
							</ListItem>
						))}
					</List>
					<Divider />
					<Typography
						level="h2"
						fontSize="md"
						sx={{ my: 2, mx: 2, color: "red" }}>
						FOR BUSINESSES
					</Typography>
					<Divider />
					<List>
						{["Create a business brockerage account", "Trash", "Spam"].map(
							(text) => (
								<ListItem key={text}>
									<ListItemButton>-{text}</ListItemButton>
								</ListItem>
							)
						)}
					</List>

					<Divider />
					<Typography
						level="h2"
						fontSize="md"
						sx={{ my: 2, mx: 2, color: "red" }}>
						ABOUT US
					</Typography>
					<Divider />
					<List>
						{["Who we are", "Milestone", "Updates"].map((text) => (
							<ListItem key={text}>
								<ListItemButton>-{text}</ListItemButton>
							</ListItem>
						))}
					</List>
				</Box> */}
				<Typography level="h2" fontSize="md" sx={{ my: 2, mx: 2 }}>
					{/* <img
						src={bullbear}
						alt="bbe"
						height="15%"
						width="15%"
						className="inline"
					/>{" "} */}
					{/* Welcome to {domain} Traders */}
				</Typography>
				{/* <img src={velLogo} alt="bbe" className="h-[15%] w-[15%]  ml-[1rem] " /> */}
				<div className=" flex justify-center items-center text-[0.9rem]   gap-2  my-[1rem]   ">
					<p
						onClick={() => {
							naviagator("/en/register");
						}}
						className=" min-w-[5rem] px-[1rem] py-[0.2rem] inline text-black   border-2     bg-white">
						Register
					</p>
					<p
						onClick={() => {
							naviagator("/en/login");
						}}
						className=" min-w-[5rem]   px-[1rem] py-[0.2rem] inline  text-white   border-2  bg-black">
						Login
					</p>

					<button
						onClick={toggleDrawer(false)}
						className="border-2   border-red-200  rounded-md px-[1rem] flex justify-center items-center  py-[0.2rem] ">
						<span className="block  text-red-400 mb-[0.3rem]">close</span>{" "}
						<IoClose className="text-[1.5rem]  text-red-400  block" />{" "}
					</button>
				</div>

				<Divider />
				{/* <Box
					sx={{
						mx: "auto",
						my: "0.5rem",
						width: "64%",
						gap: "1rem",
					}}>
					<p
						// to="/en/register"
						onClick={() => {
							naviagator("/en/register");
						}}
						className="px-[1rem] py-[0.2rem] inline text-white max-w-[4rem]  border-2  bg-red-700">
						Register
					</p>
					<p
						onClick={() => {
							naviagator("/en/login");
						}}
						// to="/en/login"
						className="px-[1rem] py-[0.2rem] inline  text-white max-w-[4rem]  border-2  bg-green-700">
						Login
					</p>
				</Box> */}
				<Divider />
				<InnerMenuAccordian />
			</Drawer>
		</Box>
	);
}
